import { takeLatest, put, call } from 'redux-saga/effects';
import { apiRequest } from '../../apiRequest';
import { URLs } from '../../urls';

import { 
	GetAnswerSheetActionsTypes, IGetAnswerSheetResult, GetAnswerSheetRequestSucces, GetAnswerSheetRequestError,
	GetAnswerSheetsActionsTypes, IGetAnswerSheetsResult, GetAnswerSheetsRequestSucces, GetAnswerSheetsRequestError,
	GetAnswerSheetsByAssessmentActionsTypes, GetAnswerSheetsByAssessmentRequestSucces, GetAnswerSheetsByAssessmentRequestError,
	CreateAnswerSheetActionsTypes, ICreateAnswerSheetResult, CreateAnswerSheetRequestSucces, CreateAnswerSheetRequestError,
	UpdateAnswerSheetActionsTypes, IUpdateAnswerSheetResult, UpdateAnswerSheetRequestSucces, UpdateAnswerSheetRequestError,
	DeleteAnswerSheetActionsTypes, IDeleteAnswerSheetResult, DeleteAnswerSheetRequestSucces, DeleteAnswerSheetRequestError,
} from './types';

// GET single answer sheet by ID
function* sendGetAnswerSheetRequest(action: any) {
	console.log('[GET ANSWER SHEET] Request for ID:', action.id);
	try {
		const response: IGetAnswerSheetResult = yield call(apiRequest, {
			endpoint: `${URLs.GET_ANSWER_SHEET_ENDPOINT}/${action.id}`,
			method: 'GET',
		});
		
		console.log('[GET ANSWER SHEET] Response:', response);
		console.log('[GET ANSWER SHEET] Data:', response.data);
		console.log('[GET ANSWER SHEET] Has imageBase64:', !!response.data?.imageBase64);

		if (response.success === true) {
			const putData: GetAnswerSheetRequestSucces = {
				type: GetAnswerSheetActionsTypes.GET_ANSWER_SHEET_SUCCESS,
				data: response,
				loading: false,
			};
			yield put<GetAnswerSheetRequestSucces>(putData);
		}

		if (response.success === false) {
			const putData: GetAnswerSheetRequestError = {
				type: GetAnswerSheetActionsTypes.GET_ANSWER_SHEET_ERROR,
				error: response.error.toString(),
				loading: false
			};
			yield put<GetAnswerSheetRequestError>(putData);
		}

	} catch (e: any) {
		const putData: GetAnswerSheetRequestError = {
			type: GetAnswerSheetActionsTypes.GET_ANSWER_SHEET_ERROR,
			error: e.message || e.toString(),
			loading: false
		};
		yield put<GetAnswerSheetRequestError>(putData);
	}
}

// GET all answer sheets for user
function* sendGetAnswerSheetsRequest(action: any) {
	const userId = localStorage.getItem("UserId");
	console.log('[GET ANSWER SHEETS] Request for userId:', userId);
	try {
		const response: IGetAnswerSheetsResult = yield call(apiRequest, {
			endpoint: `${URLs.GET_ANSWER_SHEETS_ENDPOINT}?userId=${userId}`,
			method: 'GET',
		});
		
		console.log('[GET ANSWER SHEETS] Response:', response);
		console.log('[GET ANSWER SHEETS] Answer Sheets:', response.data?.answerSheets);
		if (response.data?.answerSheets?.length > 0) {
			console.log('[GET ANSWER SHEETS] First sheet:', response.data.answerSheets[0]);
			console.log('[GET ANSWER SHEETS] First sheet has imageBase64:', !!response.data.answerSheets[0]?.imageBase64);
		}

		if (response.success === true) {
			const putData: GetAnswerSheetsRequestSucces = {
				type: GetAnswerSheetsActionsTypes.GET_ANSWER_SHEETS_SUCCESS,
				data: response,
				loading: false,
			};
			yield put<GetAnswerSheetsRequestSucces>(putData);
		}

		if (response.success === false) {
			const putData: GetAnswerSheetsRequestError = {
				type: GetAnswerSheetsActionsTypes.GET_ANSWER_SHEETS_ERROR,
				error: response.error.toString(),
				loading: false
			};
			yield put<GetAnswerSheetsRequestError>(putData);
		}

	} catch (e: any) {
		const putData: GetAnswerSheetsRequestError = {
			type: GetAnswerSheetsActionsTypes.GET_ANSWER_SHEETS_ERROR,
			error: e.message || e.toString(),
			loading: false
		};
		yield put<GetAnswerSheetsRequestError>(putData);
	}
}

// GET answer sheets by assessment ID
function* sendGetAnswerSheetsByAssessmentRequest(action: any) {
	console.log('[GET ANSWER SHEETS BY ASSESSMENT] Request for assessmentId:', action.assessmentId);
	try {
		const response: IGetAnswerSheetsResult = yield call(apiRequest, {
			endpoint: `${URLs.GET_ANSWER_SHEETS_BY_ASSESSMENT_ENDPOINT}/${action.assessmentId}`,
			method: 'GET',
		});
		
		console.log('[GET ANSWER SHEETS BY ASSESSMENT] Response:', response);
		console.log('[GET ANSWER SHEETS BY ASSESSMENT] Answer Sheets:', response.data?.answerSheets);

		if (response.success === true) {
			const putData: GetAnswerSheetsByAssessmentRequestSucces = {
				type: GetAnswerSheetsByAssessmentActionsTypes.GET_ANSWER_SHEETS_BY_ASSESSMENT_SUCCESS,
				data: response,
				loading: false,
			};
			yield put<GetAnswerSheetsByAssessmentRequestSucces>(putData);
		}

		if (response.success === false) {
			const putData: GetAnswerSheetsByAssessmentRequestError = {
				type: GetAnswerSheetsByAssessmentActionsTypes.GET_ANSWER_SHEETS_BY_ASSESSMENT_ERROR,
				error: response.error.toString(),
				loading: false
			};
			yield put<GetAnswerSheetsByAssessmentRequestError>(putData);
		}

	} catch (e: any) {
		const putData: GetAnswerSheetsByAssessmentRequestError = {
			type: GetAnswerSheetsByAssessmentActionsTypes.GET_ANSWER_SHEETS_BY_ASSESSMENT_ERROR,
			error: e.message || e.toString(),
			loading: false
		};
		yield put<GetAnswerSheetsByAssessmentRequestError>(putData);
	}
}

// POST create new answer sheet
function* sendCreateAnswerSheetRequest(action: any) {
	try {
		const userId = localStorage.getItem("UserId");
		
		const response: ICreateAnswerSheetResult = yield call(apiRequest, {
			endpoint: `${URLs.CREATE_ANSWER_SHEET_ENDPOINT}?userId=${userId}`,
			method: 'POST',
			body: action.model
		});

		if (response.success === true) {
			const putData: CreateAnswerSheetRequestSucces = {
				type: CreateAnswerSheetActionsTypes.POST_CREATE_ANSWER_SHEET_SUCCESS,
				data: response,
				loading: false,
				success: true
			};
			yield put<CreateAnswerSheetRequestSucces>(putData);
		}

		if (response.success === false) {
			const putData: CreateAnswerSheetRequestError = {
				type: CreateAnswerSheetActionsTypes.POST_CREATE_ANSWER_SHEET_ERROR,
				error: response.error.toString(),
				loading: false
			};
			yield put<CreateAnswerSheetRequestError>(putData);
		}

	} catch (e: any) {
		const putData: CreateAnswerSheetRequestError = {
			type: CreateAnswerSheetActionsTypes.POST_CREATE_ANSWER_SHEET_ERROR,
			error: e.message || e.toString(),
			loading: false
		};
		yield put<CreateAnswerSheetRequestError>(putData);
	}
}

// PUT update answer sheet
function* sendUpdateAnswerSheetRequest(action: any) {
	console.log('[UPDATE ANSWER SHEET] Action:', action);
	console.log('[UPDATE ANSWER SHEET] ID:', action.id);
	console.log('[UPDATE ANSWER SHEET] Model:', action.model);
	console.log('[UPDATE ANSWER SHEET] Endpoint:', `${URLs.UPDATE_ANSWER_SHEET_ENDPOINT}/${action.id}`);
	try {
		const response: IUpdateAnswerSheetResult = yield call(apiRequest, {
			endpoint: `${URLs.UPDATE_ANSWER_SHEET_ENDPOINT}/${action.id}`,
			method: 'PUT',
			body: action.model
		});
		console.log('[UPDATE ANSWER SHEET] Response:', response);

		if (response.success === true) {
			const putData: UpdateAnswerSheetRequestSucces = {
				type: UpdateAnswerSheetActionsTypes.PUT_UPDATE_ANSWER_SHEET_SUCCESS,
				data: response,
				loading: false,
			};
			yield put<UpdateAnswerSheetRequestSucces>(putData);
		}

		if (response.success === false) {
			const putData: UpdateAnswerSheetRequestError = {
				type: UpdateAnswerSheetActionsTypes.PUT_UPDATE_ANSWER_SHEET_ERROR,
				error: response.error.toString(),
				loading: false
			};
			yield put<UpdateAnswerSheetRequestError>(putData);
		}

	} catch (e: any) {
		const putData: UpdateAnswerSheetRequestError = {
			type: UpdateAnswerSheetActionsTypes.PUT_UPDATE_ANSWER_SHEET_ERROR,
			error: e.message || e.toString(),
			loading: false
		};
		yield put<UpdateAnswerSheetRequestError>(putData);
	}
}

// DELETE answer sheet
function* sendDeleteAnswerSheetRequest(action: any) {
	try {
		const response: IDeleteAnswerSheetResult = yield call(apiRequest, {
			endpoint: `${URLs.DELETE_ANSWER_SHEET_ENDPOINT}/${action.id}`,
			method: 'DELETE',
		});

		if (response.success === true) {
			const putData: DeleteAnswerSheetRequestSucces = {
				type: DeleteAnswerSheetActionsTypes.DELETE_ANSWER_SHEET_SUCCESS,
				data: response,
				loading: false,
			};
			yield put<DeleteAnswerSheetRequestSucces>(putData);
		}

		if (response.success === false) {
			const putData: DeleteAnswerSheetRequestError = {
				type: DeleteAnswerSheetActionsTypes.DELETE_ANSWER_SHEET_ERROR,
				error: response.error.toString(),
				loading: false
			};
			yield put<DeleteAnswerSheetRequestError>(putData);
		}

	} catch (e: any) {
		const putData: DeleteAnswerSheetRequestError = {
			type: DeleteAnswerSheetActionsTypes.DELETE_ANSWER_SHEET_ERROR,
			error: e.message || e.toString(),
			loading: false
		};
		yield put<DeleteAnswerSheetRequestError>(putData);
	}
}

export function* handler() {
	yield takeLatest(GetAnswerSheetActionsTypes.GET_ANSWER_SHEET, sendGetAnswerSheetRequest);
	yield takeLatest(GetAnswerSheetsActionsTypes.GET_ANSWER_SHEETS, sendGetAnswerSheetsRequest);
	yield takeLatest(GetAnswerSheetsByAssessmentActionsTypes.GET_ANSWER_SHEETS_BY_ASSESSMENT, sendGetAnswerSheetsByAssessmentRequest);
	yield takeLatest(CreateAnswerSheetActionsTypes.POST_CREATE_ANSWER_SHEET, sendCreateAnswerSheetRequest);
	yield takeLatest(UpdateAnswerSheetActionsTypes.PUT_UPDATE_ANSWER_SHEET, sendUpdateAnswerSheetRequest);
	yield takeLatest(DeleteAnswerSheetActionsTypes.DELETE_ANSWER_SHEET, sendDeleteAnswerSheetRequest);
}
